export default "__VITE_ASSET__DZadjrvG__"